.children {
  max-height: 0;
  overflow: hidden;

  &IsOpen {
    max-height: none;
    overflow: visible;
  }
}
